// ABOUTME: Switches between established WhatsApp conversations and isolated contact episodes.
// ABOUTME: Hides the additive pending inbox unless its rollout mode permits recruiter reads.
import React from "react";
import { Badge, Box, Tab, Tabs } from "@material-ui/core";
import {
    normalizeWhatsappContactEpisodeMode,
    shouldShowWhatsappContactEpisodeInbox
} from "./helpers";

interface WhatsappInboxScopeTabsProps {
    mode?: any;
    pendingCount: number;
    t: (key: string) => string;
    normalInbox: React.ReactNode;
    pendingInbox: React.ReactNode;
}

type WhatsappInboxVisibleScope = "CONVERSATIONS" | "CONTACT_EPISODE";

export const WhatsappInboxScopeTabs = (props: WhatsappInboxScopeTabsProps) => {
    const { mode, normalInbox, pendingCount, pendingInbox, t } = props;
    const normalizedMode = normalizeWhatsappContactEpisodeMode(mode);
    const canShowPending =
        shouldShowWhatsappContactEpisodeInbox(normalizedMode);
    const [selectedScope, setSelectedScope] =
        React.useState<WhatsappInboxVisibleScope>("CONVERSATIONS");

    React.useEffect(() => {
        if (!canShowPending) {
            setSelectedScope("CONVERSATIONS");
        }
    }, [canShowPending]);

    if (!canShowPending) {
        return <>{normalInbox}</>;
    }

    return (
        <Box
            display="flex"
            flexDirection="column"
            style={{ height: "100%", minHeight: 0 }}
        >
            <Tabs
                value={selectedScope}
                onChange={(_event, value: WhatsappInboxVisibleScope) =>
                    setSelectedScope(value)
                }
                indicatorColor="primary"
                textColor="primary"
            >
                <Tab value="CONVERSATIONS" label={t("whatsappConversations")} />
                <Tab
                    value="CONTACT_EPISODE"
                    label={
                        <Badge
                            color="secondary"
                            badgeContent={pendingCount}
                            invisible={pendingCount <= 0}
                        >
                            <Box paddingRight={pendingCount > 0 ? 2 : 0}>
                                {t("pendingContactEpisodes")}
                            </Box>
                        </Badge>
                    }
                />
            </Tabs>
            <Box flex={1} minHeight={0}>
                {selectedScope === "CONTACT_EPISODE"
                    ? pendingInbox
                    : normalInbox}
            </Box>
        </Box>
    );
};

export default WhatsappInboxScopeTabs;
